import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

const Root = styled.div`
  color: ${cbSemanticCssVars.textSecondary};
  display: flex;
  justify-content: center;
`;

export function CampaignDateRange({
  startDateTime,
  endDateTime,
  className,
}: {
  startDateTime: string;
  endDateTime: string;
  className?: string;
}) {
  return (
    <Root className={className}>
      <T.Body3>
        <FormattedMessage
          id="campaigns.analytics-data-timerange"
          values={{
            startDateTime,
            endDateTime,
          }}
        />
      </T.Body3>
    </Root>
  );
}
